import { useOktaAuth } from "@okta/okta-react";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const Public = () => {
  const navigate = useNavigate();
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate({ to: "/orgs" });
    }
  }, [authState, navigate]);

  return (
    <div className="flex items-center justify-center w-screen h-screen bg-light-100">
      <Outlet />
    </div>
  );
};

export const Route = createFileRoute("/_public")({
  component: Public,
});
